import React from "react";
import Typography from "@material-ui/core/Typography";
import { notBlank, isBlank } from "../../util/ext";
import { Box, List, ListItem, ListItemText } from "@material-ui/core";
import { identity, ifElse, length, map, pipe, pluck, reject } from "ramda";

const ErrorMessage = ({ error, ...otherProps }) => {
  return (
    <Box {...otherProps}>
      {notBlank(error) && notBlank(error.body) && (
        <Box>
          <List dense>
            {map(
              msg => (
                <ListItem>
                  <ListItemText
                    primary={msg}
                    primaryTypographyProps={{ color: "error" }}
                  />
                </ListItem>
              ),
              pipe(
                pluck("message"),
                reject(isBlank),
                ifElse(length, identity, () => [error.body.message]),
              )(error.body.errors),
            )}
          </List>
        </Box>
      )}

      {notBlank(error) && isBlank(error.body) && notBlank(error.message) && (
        <Typography color="error" variant="body1" component="div">
          {error.message}
        </Typography>
      )}
    </Box>
  );
};
export default ErrorMessage;
